import React from "react";
import { useAuth } from "../../../shared/context/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MyExpRoute } from "./types";
import { Header } from "../components/header";
import { useRegDetail } from "shared/context/regDetail";
import RegistrationState from "shared/enums/RegistrationState";

export default function PublicRoutesWrapper() {
  const auth = useAuth();
  const regDetails = useRegDetail();
  const location = useLocation();

  if (auth.isLoggedIn() && [MyExpRoute.LOGIN.path, MyExpRoute.FORGOT_PASSWORD.path].includes(location.pathname)) {
    return <Navigate to={MyExpRoute.HOME.path} replace />;
  }

  //Reg state is elapsed and user tries to access other route then redirect to elapsed screen
  if (
    regDetails.registrationState === RegistrationState.ELAPSED &&
    MyExpRoute.REGISTRATION_ELAPSED.path !== location.pathname
  ) {
    return <Navigate to={MyExpRoute.REGISTRATION_ELAPSED.path} replace />;
  }

  //User types elapsed route path, but reg state is not elapsed, then redirect to home screen
  if (
    regDetails.registrationState !== RegistrationState.ELAPSED &&
    MyExpRoute.REGISTRATION_ELAPSED.path === location.pathname
  ) {
    return <Navigate to={MyExpRoute.HOME.path} replace />;
  }

  return (
    <React.Fragment>
      <Header />
      <Outlet />
    </React.Fragment>
  );
}
